const footerLinks = [
  {
    title: '阅读功能',
    items: [
      { label: '漫蛙漫画跳章', href: '#features' },
      { label: '目录跳转', href: '#features' },
      { label: '分卷阅读', href: '#volumes' },
      { label: '章节直达', href: '#volumes' },
    ],
  },
  {
    title: '快速入口',
    items: [
      { label: '追更指南', href: '#guide' },
      { label: '热门推荐', href: '#recommend' },
      { label: '常见问题', href: '#faq' },
      { label: '关于我们', href: '#about' },
    ],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#hero" className="flex items-center gap-2" aria-label="漫蛙漫画首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-leaf-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">漫蛙漫画</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/80">
              支持跳章、目录跳转与分卷阅读的在线漫画平台，章节直达快速定位，追更效率翻倍。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="mailto:support@manwacomic.example"
                aria-label="发送邮件"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500"
              >
                <i className="ri-mail-line" aria-hidden="true"></i>
              </a>
              <a
                href="#contact"
                aria-label="联系我们"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500"
              >
                <i className="ri-message-3-line" aria-hidden="true"></i>
              </a>
              <a
                href="#recommend"
                aria-label="热门推荐"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500"
              >
                <i className="ri-fire-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((col) => (
            <nav key={col.title} className="md:col-span-2" aria-label={col.title}>
              <h4 className="text-sm font-semibold text-background-50">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.items.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      className="text-sm text-background-200/80 transition-colors hover:text-secondary-300"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-background-50">联系方式</h4>
            <p className="mt-4 text-sm text-background-200/80">support@manwacomic.example</p>
            <p className="mt-2 text-sm text-background-200/80">漫画合作与投稿同步开放</p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-50/15 pt-6 sm:flex-row">
          <p className="text-xs text-background-200/70">
            © {year} 漫蛙漫画 · 章节直达，追更从此简单
          </p>
          <a
            href="#hero"
            className="flex items-center gap-1 whitespace-nowrap rounded-full bg-background-50/10 px-4 py-2 text-xs font-medium text-background-100 transition-colors hover:bg-primary-500"
          >
            <i className="ri-arrow-up-line" aria-hidden="true"></i> 返回顶部
          </a>
        </div>
      </div>
    </footer>
  );
}